import { render, staticRenderFns } from "./AddVolume.vue?vue&type=template&id=6c0eeff2&"
import script from "./AddVolume.vue?vue&type=script&lang=js&"
export * from "./AddVolume.vue?vue&type=script&lang=js&"
import style0 from "./AddVolume.vue?vue&type=style&index=0&id=6c0eeff2&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports